/*
  ALTRA — SP のフィルタを「ライブ再描画」から「適用ボタンで一括」へ＋付随する挙動整備
  ==================================================================
  Rise の facet-filters-form は form の input イベントごとに debounce(800ms)付きで自動 submit し
  (facets.js:11)、毎回サーバー往復＋グリッド全体を再描画する。モバイルで複数条件を素早くチェックすると
  重い・反映漏れが起きる(オーナー実機報告 2026-06-25)。SP(FacetFiltersFormMobile)だけ挙動を変える。

  本スクリプトが担う4点(いずれも SP=#FacetFiltersFormMobile 限定。desktop は別フォームでライブ再描画のまま):
  (1) input 抑止: チェックの input による自動 submit を止める(capture で stopPropagation)。再描画は走らない。
  (2) 視覚同期(.active): Rise の視覚状態(選択中=赤)はサーバーの value.active=「.active クラス＋:checked」の
      二重ソースで、ライブ再描画時は submit→再描画で両者一致していた。適用方式は submit を遅延するため
      .active のサーバー更新が来ず、:checked を外しても .active が残り「両方選択中」に見える(防水/非防水の
      排他で顕在化)。そこで change のたびに全チェックボックスの .active を :checked に同期させる。
      防水軸の :checked 排他は facet-waterproof-exclusive.js(change capture)が先に正し、ここで .active を全同期。
  (3) 適用ボタン: 押下時にのみ現フォーム状態で一括 renderPage(=実フィルタ＋再描画)＋ローディングオーバーレイ。
      リスナーは capture: ボタンのインライン onclick(summary.click()=ドロワーを閉じる)より先に renderPage を
      走らせ、内部の updateURLHash で URL を即更新してから閉じる((4)の復元が適用後 URL を見るようにする順序)。
  (4) ×キャンセル(案b): ドロワーを「適用せず」閉じたら未適用の変更を破棄し、適用済み URL の状態へ戻す。
      close 時に常に URL 状態へ復元する: 適用した場合は(3)で URL 更新済み=変化なし、適用しなければ URL は
      適用前=変更破棄、と一挙に成立する。

  全リスナーは document 委譲(or 一度だけ要素バインド)で、facets.js の再描画(DOM 差し替え)後も生存する。
*/
(function () {
  var MOBILE_FORM_ID = 'FacetFiltersFormMobile';
  var WATERPROOF = 'filter.p.m.specs.waterproof';

  function getMobileForm() {
    return document.getElementById(MOBILE_FORM_ID);
  }

  // ラベルの視覚状態(.active)を input の :checked に揃える(適用方式で .active のサーバー更新が来ないため)。
  function syncMobileActive(form) {
    form.querySelectorAll('.mobile-facets__checkbox').forEach(function (checkbox) {
      var label = checkbox.closest('.mobile-facets__label');
      if (label) label.classList.toggle('active', checkbox.checked);
    });
  }

  // 適用済み URL の状態へ checked を復元する(案b の変更破棄に使う)。
  function restoreToApplied(form) {
    var params = new URLSearchParams(window.location.search);
    form.querySelectorAll('.mobile-facets__checkbox').forEach(function (checkbox) {
      checkbox.checked = params.getAll(checkbox.name).indexOf(checkbox.value) !== -1;
    });
    syncMobileActive(form);
  }

  // (1) SP: input による自動ライブ再描画を抑止(facets.js の bubble リスナーへ到達させない)。
  document.addEventListener(
    'input',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var form = target.closest('form');
      if (form && form.id === MOBILE_FORM_ID) event.stopPropagation();
    },
    true
  );

  // (2) SP: change で視覚状態(.active)を :checked に全同期。防水の :checked 排他は
  //     facet-waterproof-exclusive.js(change capture)が先に処理済みなので、ここは bubble で後追いする。
  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      if (!target || target.type !== 'checkbox' || !target.closest) return;
      var form = target.closest('form');
      if (form && form.id === MOBILE_FORM_ID) syncMobileActive(form);
    },
    false
  );

  // (3) SP: 「適用」ボタンで一括適用(renderPage)＋ローディングオーバーレイ。capture でインライン onclick より先行。
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var applyButton = target.closest('.mobile-facets__footer .button--primary');
      if (!applyButton) return;
      if (typeof FacetFiltersForm === 'undefined') return;
      var form = getMobileForm();
      if (!form) return;

      // 再描画完了(renderProductGridContainer の innerHTML 差し替え)まで覆うオーバーレイをグリッド内に挿入。
      var grid = document.getElementById('ProductGridContainer');
      if (grid && !grid.querySelector('.altra-facets-loading-overlay')) {
        var overlay = document.createElement('div');
        overlay.className = 'altra-facets-loading-overlay';
        overlay.setAttribute('aria-hidden', 'true');
        grid.appendChild(overlay);
      }

      // event を渡さない(=undefined): facets.js の部分カウント更新を避け全 facets＋グリッドを再描画(facets.js:127-159)。
      var searchParams = new URLSearchParams(new FormData(form)).toString();
      FacetFiltersForm.renderPage(searchParams);
      // ドロワーを閉じるのはボタンのインライン onclick(summary.click())が担う(本リスナーは capture で先行・非干渉)。
    },
    true
  );

  // (4) SP: ドロワーを閉じたら適用済み URL の状態へ復元(案b)。適用時は(3)で URL 更新済み=変化なし。
  function bindDisclosureCancel() {
    var disclosure = document.querySelector('.mobile-facets__disclosure');
    if (!disclosure || disclosure.dataset.altraCancelBound) return;
    disclosure.dataset.altraCancelBound = '1';
    disclosure.addEventListener('toggle', function () {
      if (disclosure.open) return; // 開いた時は何もしない
      var form = getMobileForm();
      if (form) restoreToApplied(form);
    });
  }
  bindDisclosureCancel();
})();
